export default [
    {
        description:
            'Make your payment directly into our bank account. Please use your Order ID as the payment reference. ' +
            'Your order will not be shipped until the funds have cleared in our account.',
        key: 'bank',
        title: 'Direct bank transfer',
    },
    {
        description: 'Please send a check to Store Name, Store Street, Store Town, Store State County, Store Postcode.',
        key: 'check',
        title: 'Check payments',
    },
    {
        description: 'Pay with cash upon delivery.',
        key: 'cash',
        title: 'Cash on delivery',
    },
    {
        description: 'Pay via PayPal; you can pay with your credit card if you don’t have a PayPal account.',
        key: 'paypal',
        title: 'PayPal',
    },
];
